import { render } from "./Learning.vue?vue&type=template&id=0e86034e&scoped=true"
import script from "./Learning.vue?vue&type=script&lang=js"
export * from "./Learning.vue?vue&type=script&lang=js"

import "./Learning.vue?vue&type=style&index=0&id=0e86034e&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e86034e"]])

export default __exports__